// import { useMutation, useQueryClient } from '@tanstack/react-query';
// import toast from 'react-hot-toast';
// import { menuServices } from '../services/menu.service';
// import { parseApiError } from 'features/menu/hooks/useMenus';

// export const useUploadMenuImage = () => {
//   const queryClient = useQueryClient();

//   return useMutation({
//     /**
//      * payload shape:
//      * {
//      *   file:          File
//      *   menuId:        string
//      *   subcategoryId: string   ✅ was categoryName
//      *   itemSlug:      string
//      * }
//      */
//     mutationFn: async ({ file, menuId, subcategoryId, itemSlug }) => {

//       // Step 1: upload file to S3, get back { url, key }
//       const uploaded = await menuServices.uploadImage(file);

//       const image = {
//         url:       uploaded?.data?.key,    // ✅ persist key as url — signed URL
//         key:       uploaded?.data?.key,    //    is generated on read by transformer
//         isPrimary: true,
//       };

//       // Step 2: attach S3 key to the item via manage endpoint
//       return await menuServices.updateMenuImage({
//         menuId,
//         subcategoryId,    // ✅ was categoryName
//         itemSlug,
//         image,
//       });
//     },

//     onSuccess: () => {
//       toast.success('Image updated');

//       queryClient.invalidateQueries({
//         queryKey: ['menus'],
//       });
//     },

//     onError: (error) => {
//       const parsed = parseApiError(error);
//       toast.error(parsed.message || 'Upload failed');
//     },
//   });
// };




import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { menuServices } from '../services/menu.service';
import { parseApiError } from 'features/menu/hooks/useMenus';

export const useUploadMenuImage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ file, menuId, subcategoryId, itemSlug }) => {

      // Step 1: upload file to S3
      const uploaded = await menuServices.uploadImage(file);

      const image = {
        url:       uploaded?.data?.key,
        key:       uploaded?.data?.key,
        isPrimary: true,
      };

      // Step 2: attach key to the item
      await menuServices.updateMenuImage({
        menuId,
        subcategoryId,
        itemSlug,
        image,
      });

      // ✅ Return the S3 upload data so onSuccess / mutate callbacks can use it
      return uploaded?.data;
    },

    onSuccess: () => {
      toast.success('Image updated');

      queryClient.invalidateQueries({
        queryKey: ['menus'],
      });
    },

    onError: (error) => {
      const parsed = parseApiError(error);
      toast.error(parsed.message || 'Upload failed');
    },
  });
};